<template>
  <div class="mb-4">
    <validation-provider :rules="{ required: !isOptional }" :disabled="isOptional" v-slot="{ errors }" :immediate="validateImmediate">
      <h6 v-if="displayError(errors, number + question.questionText)" class="text-danger">{{ errors[0] }}</h6>
      <div 
        v-if="question.questionText && question.questionText.length > 0" 
        class="mb-1" 
        :style="{ 'background-color': questionBackColor }">
        <span v-html="number" class="number-text"></span><span v-html="question.questionText"></span>
      </div>
      <div v-html="question.instructions" class="font-italic mb-1"></div>
      <div v-if="debugQuestions" class="text-warning">{{ isOptional }} {{ question.hspCategoryQuestionId }} (state text: {{ stateResponseTextValue }}))</div>
      <div class="row">
        <div class="col-sm-6 col-lg-4" style="margin: 0 auto">
          <base-input
            :responsesBackColor="responsesBackColor"
            :value="stateResponseTextValue"
            :isMultiline="isMultiline"
            :maxLength="max"
            :type="type"
            :readonly="readonly"
            :textAlign="textAlign"
            :fontSize="fontSize"
            :fontWeight="fontWeight"
            @input="handleInput"></base-input>
          <div v-if="isMultiline && max">Characters Left: {{ charactersLeft }}</div>
        </div>
      </div>
    </validation-provider>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import { randomCode } from 'src/modules/utils';

export default {
  components: {
    ValidationProvider
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    number: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    validateImmediate: Boolean,
    missingResponseSection: Object,
  },
  data() {
    return {
      value: null,
      max: undefined,
      readonly: true,
      textAlign: "center",
      fontSize: "1.5em",
      fontWeight: "bold",
      randomCode: null,
    }
  },
  computed: {
    ...mapGetters(['activeSectionId', 'debugQuestions']),
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if (this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    randomCodeCreated() {
      return this.randomCode && this.randomCode.length > 0 ? true : false;
    },
    stateResponseTextValue() {
      let responses = this.$store
        .getters
        .getQuestionResponses(this.question.hspCategoryQuestionId)

      if (responses.length) {
        return responses[0].responseTextValue;
      }

      return null;
    },
    isMultiline() {
      return this.question.hspQuestionTypeId === 4;
    },
    charactersLeft() {
      if (this.stateResponseTextValue) {
        return this.max - this.stateResponseTextValue.length;
      }

      return this.max;
    },
    type() {
      return this.missingResponseSection ? "password" : null;
    },
  },
  methods: {
    displayError(error, description = "") {
      let display = error.length > 0 && error[0].length > 0;
      // console.log("In RandomCode.vue -- error:");
      // console.log(error);
      // console.log((description.length > 0 ? "for [" + description + "]: " : "") + "display = [" + display + "]");
      return display;
    },
    handleInput: function(value) {
      this.$store.dispatch('setQuestionResponse', {
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseText: value
      });
    },
    generateCode() {
      // Create a code with 8 alphanumeric characters with at least 3 numbers in the code.
      this.randomCode = randomCode(8, 3);
      this.putData();
    },
    putData() {
      this.handleInput(this.randomCode);
      this.$emit('putResponse', this.question.hspCategoryQuestionId);
    },
  },
  watch: {
    isDisplayed: function(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }

      if (newValue) {
        if (this.randomCodeCreated) {
          // Sync the randomCode to the [simulated] responded input value.
          if (this.randomCode !== this.stateResponseTextValue) {
            this.putData();
          }
          return;
        }

        this.generateCode();
      }
    },
  },
  created() {
    this.question.questionOptions.forEach(option => {
      if(this.hasOwnProperty(option.optionName)) {
        this[option.optionName] = option.optionValue;
      }
    });

    // Initialize existing random code, if any.
    if (this.stateResponseTextValue && this.stateResponseTextValue.length > 0) {
      this.randomCode = this.stateResponseTextValue;
    }
    if (this.isDisplayed && !this.randomCodeCreated) {
      this.generateCode();
    }
  },
}
</script>
